import script from "./SnsConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SnsConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./SnsConfirmModal.vue?vue&type=style&index=0&id=ebe76432&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebe76432"]])

export default __exports__